/** The Akhara mark — clay-pit ring + rising double chevron. Inherits color via
 *  the `text-*` class on a wrapper (defaults to terracotta when unstyled). */
export default function Mark({ className = 'h-7 w-7 text-terracotta-500' }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Akhara" fill="none">
      <circle cx="32" cy="32" r="23" stroke="currentColor" strokeWidth="5" />
      <path
        d="M20 35 L32 23 L44 35"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 45 L32 33 L44 45"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
